exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price{white-space:nowrap}\n", ""]);

// exports
exports.locals = {
	"price": "price"
};